import { useState } from "react";
import { trendingTitles } from "@/mocks/anime";

const stats = [
  { value: "12,000+", label: "热门番剧" },
  { value: "4K", label: "超清画质" },
  { value: "0", label: "广告干扰" },
  { value: "1键", label: "开刷连播" },
];

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!keyword.trim()) return;
    document.getElementById("hot")?.scrollIntoView({ behavior: "smooth" });
    setKeyword("");
  };

  return (
    <section
      id="home"
      className="relative flex min-h-[560px] items-center overflow-hidden pt-24 md:min-h-[640px] md:pt-28"
      style={{
        backgroundImage:
          "url('https://readdy.ai/api/search-image?query=Breathtaking%20anime%20wide%20panorama%20of%20a%20heroic%20young%20warrior%20with%20glowing%20sword%20standing%20on%20a%20floating%20cliff%20above%20clouds%2C%20dramatic%20orange%20sunset%20and%20teal%20aurora%20sky%2C%20epic%20cel%20shaded%20illustration%2C%20cinematic%20lighting%2C%20vibrant%20colors%2C%20clean%20composition&width=1600&height=900&seq=anime-hero-bg&orientation=landscape')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/45 to-foreground-950/75" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs text-background-50 backdrop-blur-sm">
            <i className="ri-flashlight-fill text-secondary-400" />
            无广告 · 高清 · 全集连播 · 一口气开刷
          </span>

          <h1 className="max-w-4xl font-heading text-4xl leading-tight text-background-50 md:text-6xl md:leading-tight">
            卡通动漫综合
            <span className="text-gradient"> 免费看高清全集</span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100/90 md:text-base">
            主打卡通动漫综合免费看与高清无广告体验，页面纯净、播放流畅。支持全集与一口气连播模式，
            适合想连续补番的你直接开刷，追番永不掉队。
          </p>

          <form
            onSubmit={handleSearch}
            className="mt-8 flex w-full max-w-xl items-center overflow-hidden rounded-full border border-background-50/30 bg-background-50/95 p-1.5 shadow-soft focus-within:ring-2 focus-within:ring-primary-400"
            aria-label="全站搜索动漫"
          >
            <i className="ri-search-line pl-4 text-lg text-foreground-500" />
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入番剧名，立即搜索开刷…"
              className="h-12 flex-1 bg-transparent px-3 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
            <button
              type="submit"
              className="mr-1 flex h-11 items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-search-line" />
              搜索
            </button>
          </form>

          <div className="mt-6 flex flex-wrap items-center justify-center gap-2 text-xs text-background-100/80">
            <span className="mr-1 text-background-100/60">大家都在看：</span>
            {trendingTitles.slice(0, 6).map((t) => (
              <a
                key={t}
                href="#hot"
                className="whitespace-nowrap rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1 text-background-50/90 transition-colors hover:bg-primary-500/70"
              >
                {t}
              </a>
            ))}
          </div>

          <div className="mt-10 grid w-full max-w-2xl grid-cols-2 gap-3 sm:grid-cols-4">
            {stats.map((s) => (
              <div
                key={s.label}
                className="rounded-2xl border border-background-50/15 bg-background-50/10 px-4 py-4 text-center backdrop-blur-sm"
              >
                <div className="font-heading text-2xl text-secondary-300 md:text-3xl">{s.value}</div>
                <div className="mt-1 text-xs text-background-100/75">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 hidden -translate-x-1/2 items-center gap-2 text-background-100/70 md:flex">
        <i className="ri-arrow-down-s-line animate-bounce text-lg" />
        <span className="text-xs">向下滚动，开始追番</span>
      </div>
    </section>
  );
}